import { InputWithLabel } from '@adotel/components'
import { Typography, Grid, Switch, IconButton, Hidden } from '@material-ui/core'
import RightIcon from '@material-ui/icons/ArrowRightAlt'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { useState } from 'react'

import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { PMSMappingForAccommodation } from '../../types/accommodationPMSMapping'
import useStyles from './styles/index.styles'

interface AccommodationDetailsContainerProps {
  propertyCode: string
  accommodationName: string
  haveSuppurtRatePlans: boolean
  setHaveSuppurtRatePlans: React.Dispatch<React.SetStateAction<boolean>>
  PMSMappingForAccommodationInput: PMSMappingForAccommodation
  setPMSMappingForAccommodationInput: React.Dispatch<
    React.SetStateAction<PMSMappingForAccommodation>
  >
}

export const AccommodationDetailsContainer: React.FC<
  AccommodationDetailsContainerProps
> = ({
  propertyCode,
  accommodationName,
  haveSuppurtRatePlans,
  setHaveSuppurtRatePlans,
  PMSMappingForAccommodationInput,
  setPMSMappingForAccommodationInput
}) => {
  const classes = useStyles()
  const [visibilityIconClicked, setVisibilityIconClicked] = useState(false)

  const clickOnShowPassword = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation()
    setVisibilityIconClicked(!visibilityIconClicked)
  }

  const isPersian = persianRegex.test(accommodationName)

  return (
    <div className={classes.accommodationDetailsContainer}>
      <div>
        <div className={classes.itemBox}>
          <Typography
            variant="h4"
            className={classes.title}
            style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
            {accommodationName}
          </Typography>
          <div className={classes.codeMappingContianer}>
            <div>
              <InputWithLabel
                noHelperText
                label={getTranslate('Adotel Code')}
                viewMode
                value={propertyCode}
                inputSize="small"
              />
            </div>
            <Hidden smDown>
              <RightIcon />
            </Hidden>
            <div className={classes.mappedCodeContainer}>
              <InputWithLabel
                value={PMSMappingForAccommodationInput?.PMSCode}
                noHelperText
                label={getTranslate('Mapped Code')}
                inputSize="small"
                onChange={(event) => {
                  setPMSMappingForAccommodationInput({
                    ...PMSMappingForAccommodationInput,
                    PMSCode: event.currentTarget.value
                  })
                }}
                error={!PMSMappingForAccommodationInput.PMSCode}
                autoComplete="new-password"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={classes.pmsPasswordContainer}>
        <InputWithLabel
          label={getTranslate('PMS password')}
          endIcon={
            <IconButton onClick={(event) => clickOnShowPassword(event)}>
              {!visibilityIconClicked ? (
                <VisibilityOffIcon />
              ) : (
                <VisibilityIcon />
              )}
            </IconButton>
          }
          inputSize="small"
          placeholder={getTranslate('Enter password')}
          autoComplete="new-password"
          type={visibilityIconClicked ? 'text' : 'password'}
          value={PMSMappingForAccommodationInput?.PMSPass}
          fullWidth
          onChange={(event) => {
            if (PMSMappingForAccommodationInput) {
              setPMSMappingForAccommodationInput?.({
                ...PMSMappingForAccommodationInput,
                PMSPass: event.currentTarget.value
              })
            }
          }}
        />
      </div>
      <div className={classes.switchContainer}>
        <Typography variant="h4">
          {getTranslate("Does this accommodation's PMS Supports rateplans?")}
        </Typography>
        <Typography component="div" className={classes.switch}>
          <Grid
            component="label"
            container
            alignItems="center"
            justify="flex-start">
            <Grid item>{getTranslate('No')}</Grid>
            <Grid item>
              <Switch
                data-cy="AccommodationPMSMappingHaveRatePlanSwitch"
                name="checkRatePlans"
                color="primary"
                onChange={() => {
                  setHaveSuppurtRatePlans(!haveSuppurtRatePlans)
                }}
                checked={haveSuppurtRatePlans}
              />
            </Grid>
            <Grid item>{getTranslate('Yes')}</Grid>
          </Grid>
        </Typography>
      </div>
      <div className={classes.switchContainerActive}>
        <Typography variant="h4">{getTranslate('Active')}</Typography>
        <Typography component="div" className={classes.switch}>
          <Grid
            component="label"
            container
            alignItems="center"
            justify="flex-start">
            <Grid item>{getTranslate('No')}</Grid>
            <Grid item>
              <Switch
                name="active"
                color="primary"
                onChange={() => {
                  // setHaveSuppurtRatePlans(!haveSuppurtRatePlans)
                }}
                checked={
                  // customizedForChannel
                  //   ? selectedChannel?.Active
                  //   : PMSMappingsAccommodationList?.Active
                  true
                }
                disabled={true}
              />
            </Grid>
            <Grid item>{getTranslate('Yes')}</Grid>
          </Grid>
        </Typography>
      </div>
    </div>
  )
}
